import { render } from "./OrderTeaser.vue?vue&type=template&id=4870b94d&scoped=true"
import script from "./OrderTeaser.vue?vue&type=script&lang=js"
export * from "./OrderTeaser.vue?vue&type=script&lang=js"

import "./OrderTeaser.vue?vue&type=style&index=0&id=4870b94d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4870b94d"]])

export default __exports__